import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { Router } from "@angular/router";
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from "@angular/material/form-field";

@Component({
    selector: "app-home",
    templateUrl: "./home.component.html",
    styleUrls: ["./home.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
    // Outlined fields on every tab (look only; colours in home.component.scss).
    // The Form Editor tab refines this in FormsComponent.
    providers: [
        {
            provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
            useValue: { appearance: "outline" },
        },
    ],
})
export class HomeComponent {
  private router = inject(Router);

  onAreas() {
    this.router.navigate(["/areas"]);
  }
  onBranch() {
    this.router.navigate(["/branches"]);
  }

  onBranchAdmin() {
    this.router.navigate(["/branch-admins"]);
  }

  onTypes() {
    this.router.navigate(["/types"]);
  }

  onStatuses() {
    this.router.navigate(["/statuses"]);
  }

  onPriorities() {
    this.router.navigate(["/priorities"]);
  }

  onDepartments() {
    this.router.navigate(["/departments"]);
  }

  onProductCategories() {
    this.router.navigate(["/categories"]);
  }

  onFormTypes() {
    this.router.navigate(["/formtypes"]);
  }

  onChains() {
    this.router.navigate(["/chains"]);
  }

  onChainAdmins() {
    this.router.navigate(["/chain-admins"]);
  }

  onUserAttributes() {
    this.router.navigate(["/user-attributes"]);
  }

  onInstallationAttributes() {
    this.router.navigate(["/installation-attributes"]);
  }
}
